import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import ComboAbmZonUbicaciones from "../../Componentes/Compuestos/Combos/ComboAbmZonUbicaciones";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion"
import { DateBox, NumberBox } from "devextreme-react";
import LV_ART_Articulos_SelectorSimple from "../../Componentes/Compuestos/Complejos/Articulos/LV_ART_Articulos_SelectorSimple";
import { FormateoFechaPara_yyyyMMdd_HHmmss, ObtieneParametros, TratamientoDeVariableBoolean } from "neftis7_apicaller/src/funciones/Varios";
import { function_PRO_Fabricacion_Cabecera_InsertarBasico } from "neftis7_apicaller/src/funciones/PRO/PRO_Fabricacion_Cabecera";

export const PRO_Fabricacion_ModificacionCreacion_Simplificada = () => {

  let Codigo = useParams()

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [fecha, setFecha] = useState(new Date());
  const [cantidad, setCantidad] = useState(1);
  const [codigoArticulo, setCodigoArticulo] = useState("")
  const [codigoPresentacion, setCodigoPresentacion] = useState("")
  const [codigoTamano, setCodigoTamano] = useState("")
  const [codigoUnidadMedida, setCodigoUnidadMedida] = useState("")
  const [codigoUbicacion, setCodigoUbicacion] = useState("")
  const [objetoParaFabricar, setObjetoParaFabricar] = useState([]);
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false);
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false);
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const onClickAgregar = () => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);
      
      if (cantidad < 1) {
        alert("La cantidad debe ser mayor a cero.");
        return;
      }

      if (!codigoArticulo || codigoArticulo === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      if (!codigoPresentacion || codigoPresentacion === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      if (!codigoTamano || codigoTamano === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      if (!codigoUnidadMedida || codigoUnidadMedida === "") {
        alert("Es necesario seleccionar un Artículo.");
        return;
      }

      if (!codigoUbicacion || codigoUbicacion === "") {
        alert("Es necesario seleccionar una Ubicación.");
        return;
      }

      const Agregar = async () => {
        setLoading(true)

        const dataOperacion = {
          Fecha: await FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
          CodigoPlanta: localStorage.getItem("CodigoPlanta"),
          Terminal: localStorage.getItem("Terminal"),
          CodigoArticuloFabricado: codigoArticulo,
          CodigoPresentacionFabricado: codigoPresentacion,
          CodigoTamanoFabricado: codigoTamano,
          CodigoUnidadMedidaFabricado: codigoUnidadMedida,
          CantidadFabricado: cantidad,
          CodigoUbicacionOrigen: codigoUbicacion,
          CodigoUbicacionDestino: codigoUbicacion,
          CodigoUbicacionEgreso: codigoUbicacion,
          CodigoUbicacionIngreso: codigoUbicacion
        };

        const resultIdFabricacion = await function_PRO_Fabricacion_Cabecera_InsertarBasico(dataOperacion)

        alert("Se ha creado la Fabricación Nº " + resultIdFabricacion.data.codigoGenerado)
      }

      Agregar();
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false)
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const datosModificadores = await ObtieneParametros();
        setGlobalUsaArticulosConPresentacion(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion))
        setGlobalUsaArticulosConTamano(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano))
        setGlobalUsaArticulosConUnidadDeMedida(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida))

        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setCodigoArticulo(objetoParaFabricar.CodigoArticulo)
    setCodigoPresentacion(objetoParaFabricar.CodigoPresentacion)
    setCodigoTamano(objetoParaFabricar.CodigoTamano)
    setCodigoUnidadMedida(objetoParaFabricar.CodigoUnidadMedida)
  }, [objetoParaFabricar]);

  return (
    <PaginaCarga
      Titulo="FABRICACIÓN SIMPLIFICADA"
    >
      <div className="LV-GroupBox-div"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center' }}
      >
        <div className="LV-FlexContainer" style={{ gap: 42, marginBottom: 20 }}>
          Fecha:
          <DateBox width={140} displayFormat="dd/MM/yyyy"
            value={fecha}
            style={{ marginLeft: '5px', marginRight: '20px' }}
            onValueChanged={(e) => setFecha(e.value)} />
        </div>
        <div className="LV-FlexContainer" style={{ gap: 30, marginBottom: 20 }}>
          <LV_ART_Articulos_SelectorSimple
            Comprables={0}
            Vendibles={0}
            Fabricables={1}
            Stockeables={0}
            Servicios={0}
            ExcluirVendibles={0}
            ExcluirComprables={0}
            ExcluirFabricables={0}
            ExcluirStockeables={0}
            ExcluirServicios={0}
            actualizarObjetoParaAgregar={setObjetoParaFabricar}
            tienePresentaciones={globalUsaArticulosConPresentacion}
            tieneTamanos={globalUsaArticulosConTamano}
            tieneUnidadesMedida={globalUsaArticulosConUnidadDeMedida} />
        </div>
        <div className="LV-FlexContainer" style={{ gap: 20, marginBottom: 20 }}>
          Ubicación:
          <ComboAbmZonUbicaciones
            onValueChanged={(e) => setCodigoUbicacion(e.value)}
            ancho={"500"}
            style={{ marginLeft: '5px', marginRight: '20px' }} />
        </div>
        <div className="LV-FlexContainer" style={{ gap: 25, marginBottom: 20 }}>
          Cantidad:
          <NumberBox style={{ marginLeft: '5px', marginRight: '40px', width: '50px' }}
            value={cantidad}
            onValueChanged={(e) => setCantidad(e.value)} />
        </div>
        <LVButtonAccion
          Disabled={cierreEnProceso}
          Texto="FABRICAR"
          Ancho={"100%"}
          onClick={onClickAgregar}
        />
      </div>
    </PaginaCarga>
  );
}
